// extracted by mini-css-extract-plugin
export var container = "_5y-1";
export var editor = "_5y-2";
export var resizable = "_5y-3";
export var wrapper = "_5y-0";